import React, { useEffect, useState } from "react";
import logo from "../../images/logo.png";
import { scAxiosAdmin, thirdparty } from "../../";
import { USER_LOCAL_ID, USER_ROLE } from "../../constants";
const LeftSidebar = () => {
  const [userData, setUserData] = useState(null);
  const menus = [
    {
      title: "Departments",
      icon: "dripicons-briefcase",
      link: "/admin/departments",
    },
    {
      title: "Doctors",
      icon: "dripicons-briefcase",
      link: "/admin/doctors",
    },
    {
      title: "Members",
      icon: "dripicons-blog",
      link: "/admin/boardmembers",
    },
    {
      title: "Case Studies",
      icon: "dripicons-blog",
      link: "/admin/case_studies",
    },
    {
      title: "Appointment Requests",
      icon: "dripicons-blog",
      link: "/admin/appointment/request",
    },
    {
      title: "Appointment Bookings",
      icon: "dripicons-blog",
      link: "/admin/appointment/booking",
    },
    {
      title: "Video Uploading JCI",
      icon: "dripicons-blog",
      link: "/admin/uploading",
    },
    // {
    //   title: "Set SSL Commerz",
    //   icon: "dripicons-blog",
    //   link: "/admin/set_ssl_commerz",
    // },
    {
      title: "Testimonials",
      icon: "dripicons-blog",
      link: "/admin/testimonials",
    },
    {
      title: "News Events",
      icon: "dripicons-blog",
      link: "/admin/newsevents",
    },
    {
      title: "Publications",
      icon: "dripicons-blog",
      link: "/admin/publications",
    },
    {
      title: "Media Upload",
      icon: "dripicons-blog",
      link: "/admin/upload-media",
    },
    {
      title: "Home page popup",
      icon: "dripicons-blog",
      link: "/admin/home-popup",
    },
    {
      title: "Packages",
      icon: "dripicons-blog",
      link: "/admin/packages",
    },
    {
      title: "Investigations",
      icon: "dripicons-blog",
      link: "/admin/investigations",
    },
    {
      title: "Static Pages",
      icon: "dripicons-blog",
      link: "/admin/staticpages",
    },
    // {
    //   title: "Menu",
    //   icon: "dripicons-blog",
    //   link: "/admin/menu",
    // },
    {
      title: "Banner",
      icon: "dripicons-blog",
      link: "/admin/banner/list",
    },
    {
      title: "Banner Button Link",
      icon: "dripicons-blog",
      link: "/admin/bannerbuttonlink",
    },
    {
      title: "Body Links",
      icon: "dripicons-blog",
      link: "/admin/body-links",
    },
    {
      title: "Album",
      icon: "dripicons-blog",
      link: "/admin/albums",
    },
    {
      title: "Video Gallery",
      icon: "dripicons-blog",
      link: "/admin/videogallery",
    },
    {
      title: "Messages",
      icon: "dripicons-blog",
      link: "/admin/emergency-inquiry-messages",
    },
    {
      title: "Role Permission",
      icon: "dripicons-user-group",
      link: "/admin/role-manager",
    },
    {
      title: "User Log",
      icon: "dripicons-user-group",
      link: "/admin/user-log",
    },
  ];

  const fetchUserData = async (e) => {
    try {
      let user_id = localStorage.getItem(USER_LOCAL_ID);
      const response = await thirdparty.get(`/user/detail/${user_id}`);
      if (response.status === 200) {
        setUserData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <div className="left side-menu" style={{ overflowY: "auto" }}>
      <div className="topbar-left">
        <div className="">
          <a href="/admindashboard" className="logo">
            <img src={logo} height={65} alt="logo" />
          </a>
        </div>
      </div>
      <div className="sidebar-inner slimscrollleft">
        <div id="sidebar-menu">
          <ul>
            <li className="has_sub">
              <a href="/admindashboard" className="waves-effect">
                <i className="dripicons-device-desktop"></i>
                <span> Dashboard </span>
              </a>
            </li>
            {userData != null
              ? menus.map((menu) => {
                return !!userData.roles &&
                  (userData.roles.id == 1 ||
                    userData.roles.permission.includes(menu.link)) ? (
                  <li key={menu.link}>
                    <a href={menu.link} className="waves-effect">
                      <i className={menu.icon}></i>
                      <span> {menu.title} </span>
                    </a>
                  </li>
                ) : null;
              })
              : null}{" "}
            <li>
              <a href="/admin/configuration" className="waves-effect">
                <i className="dripicons-blog"></i>
                <span>Configuration</span>
              </a>
            </li>
            <li>
              <a href="/admin/email-configuration" className="waves-effect">
                <i className="dripicons-blog"></i>
                <span>Email Configuration</span>
              </a>
            </li>

            <li>
              <a href="/admin/settings" className="waves-effect">
                <i className="dripicons-blog"></i>
                <span>Settings</span>
              </a>
            </li>
            {/* <li className="has_sub">
              <a href="/adminlogout" className="waves-effect">
                <i className="dripicons-exit"></i>
                <span> Logout </span>
              </a>
            </li> */}
            {/*<li className="menu-title">Main</li>*/}
            {/* <li>
            <a href="//admin/headerannoucement" className="waves-effect">
              <i className="dripicons-blog"></i>
              <span> Header Annoucement </span>
            </a>
          </li> */}
          </ul>
        </div>
        <div className="clearfix"></div>
      </div>
    </div>
  );
};

export default LeftSidebar;



// WEBPACK FOOTER //
// ./src/component/admin/LeftSidebar.js